/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    cov: {
        id: 'quoteandbind.PCTBuiRiskLinedirectives.templates.Information.Coverages',
        defaultMessage: 'Coverages'
    },
    form:{
        id: 'quoteandbind.PCTBuiRiskLinedirectives.templates.Information.Endorsements',
        defaultMessage: 'Endorsements'
    },
    totalInsValue: {
        id: 'quoteandbind.PCTBuiRiskLinedirectives.templates.Information.Total Insured Value',
        defaultMessage: 'Total Insured Value : '
    }

});